
import CommonMessageBox from "./CommonMessageBox"

export default  {
    CommonMessageBox,
}